import * as axios from 'axios';
import { ARCGIS_LAYER_VERSION_TAG } from '../lib/constants';
import { getConfig } from '../lib/config';
import { getAuthHeaders } from '../lib/request';
import { userRequest } from '../lib/userRequest';

export const getLayerForState = async (stateName) => {
  const headers = getAuthHeaders();
  const geoUrl =
    process.env.NODE_ENV == 'development' &&
    process.env.REACT_APP_GEO_SERVICE_URL != null
      ? process.env.REACT_APP_GEO_SERVICE_URL
      : getConfig('SERVER_ARC_GIS');

  return axios({
    headers,
    baseUrl: '',
    url: `${geoUrl}/rest/services/Hosted/${stateName}${ARCGIS_LAYER_VERSION_TAG}/FeatureServer/layers?f=pjson`,
    // url: `${geoUrl}/arcgis/rest/services/Hosted/${stateName}${ARCGIS_LAYER_VERSION_TAG}/FeatureServer/layers?f=pjson`,
  })
    .then((response) => {
      return {
        success: true,
        stateName,
        data: response.data,
      };
    })
    .catch((error) => {
      return { success: false, data: error };
    });
};

export const getAllLayers = async () => {
  return userRequest(
    'get',
    '/layers-manifest',
    {},
    true
  );
};